<template>

<div>
  <div class="principal" :class="(isMobile)?'sectionMovil':'sectionWeb'">
    <section>
      <form @submit.prevent="onSubmit" class="formulario">
        <center><img src="/img/gesto/alt60px_logo-gesto2.png" style="height: 90px;"></center>
        <h3 class="text-center" style="color:#fff">Solicitud de Registro</h3>
        <hr>
        <h5 style="color:#fff">Datos de la empresa</h5>
        <div class="row">
          <div class="col-4">
            <div class="inputbox">
              <input 
                autocomplete="off"
                type="text" 
                required
                v-model="formData.nombreEmpresa"
              >
              <label for="">Nombre de la Empresa</label>
            </div>
          </div>
          <div class="col-4 ">
            <div class="inputbox">
              <input type="text" required
                autocomplete="off"
                v-model="formData.rutEmpresa"
                @keyup="formatearRutEmpresa"
              >
              <label for="">Rut de la Empresa</label>
            </div>
          </div>
          <div class="col-4">
            <div class="inputbox">
              <input type="text" required
                v-model="formData.telefono"
                @keyup="formatearTelefono"
              >
              <label for="">Telefono de contacto</label>
            </div>
          </div>
        </div>
        <hr><br>
        <div v-for="(usuario, index) in formData.usuarios" :key="index">
          <h5 style="color:#fff">Datos Usuario {{ index == 0? 'Admin': index + 1 }}</h5>
          <div class="row">
            <div class="col-4">
              <div class="inputbox">
                <input type="text" required
                  v-model="usuario.nombre"
                >
                <label for="">Nombre</label>
              </div>
            </div>
            <div class="col-4">
              <div class="inputbox">
                <input type="text" required
                  v-model="usuario.apellido"
                >
                <label for="">Apellido</label>
              </div>
            </div>
            <div class="col-4">
              <div class="inputbox">
                <input type="text" required
                  @keyup="formatearRutUsuario(usuario)"
                  v-model="usuario.rutUsuario"
                >
                <label for="">Rut del Usuario</label>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-4">
              <div class="inputbox">
                <input type="text" required
                  v-model="usuario.nombreUsuarioX"
                >
                <label for="">Nombre de Usuario Vapp</label>
              </div>
            </div>
            <div class="col-4">
              <div class="inputbox">
                <input type="text" required
                  v-model="usuario.correoUsuario"
                  :is-valid="usuario.validarCorreo"
                  @blur="validarCorreo(usuario)"
                >
                <label for="">Correo Electronico</label>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <button
               class="btnEliminarUsuario btn btn-danger"
                v-if="formData.usuarios.length > 1"
                @click="eliminarUsuario(index)"
              >
                Quitar Usuario
              </button>
            </div>
          </div>
          <hr><br>
        </div>
        <button shape="pill"
            @click="agregarUsuario"
            class="btnAgregarUsuario">
          Agregar Usuario
        </button>
        <div class="row">
          <div class="col-6">
            <button class="mt-4 w-100 btnNormalVappFormulario" @click="volverLogin" shape="pill">
              Volver al Login
            </button>
          </div>
          <div class="col-6" v-show="mostrarRegistrar">
            <button :disabled="registrando"  class="mt-4 w-100 btnNormalVappFormulario" @click="volverLogin" shape="pill"
            v-tippy="{
                  content: 'Puede registrar más usuarios después de registrarse',
                  followCursor: true,
                  placement: 'top',
                  theme: 'google',
                  animation: 'fade',
                  arrow: 'true',
                  arrowType: 'round',
                  delay: '100',
                  duration: '[200, 100]',
              }">
              <CIcon v-show="registrando" name="cil-loop-circular"class="imgr" />
              Registrarse
            </button>
          </div>
        </div>
      </form>
    </section>
  </div>
</div>

</template>

<script>

import cons from '@/const'
import axios from "axios"
import * as util from '@/views/utils/utilsFunctions'

export default {
  name: "FormularioRegistro",
  data() {
    return {
      regMail: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
      
      mostrarRegistrar: true,
      registrando: false,

        isMobile: false,

        urlBase: cons.port + "://" + cons.ipServer,
      formData: {
        nombreEmpresa: "",
        rutEmpresa: null,
        rutEmpresaValidado: true,
        telefono: "",
        telefonoError: "",
        usuarios: [
          {
            nombre: "",
            apellido: "",
            nombreUsuarioX: "",
            rutUsuario: null,
            rutUsuarioValidado: true,
            correoUsuario: null,
            correoUsuarioValidado: true,
          },
        ],
      },
    };
  },
  methods: {
    agregarUsuario() {
      this.formData.usuarios.push({
        nombre: "",
        apellido: "",
        nombreUsuarioX: "",
        rutUsuario: "",
        correoUsuario: "",
      });
    },
    eliminarUsuario(index) {
      this.formData.usuarios.splice(index, 1);
    },
    volverLogin: function () {
        this.$router.push({ name: 'Login' });
    },
    onSubmit() {
      this.registrando = true
        // Implementa la lógica para enviar los datos al servidor
        let url = this.urlBase + "/registro_gesto/"
        axios({
            method: "POST",
            url: url,
            data: {
                datosRegistro: {
                    nombreEmpresa: this.formData.nombreEmpresa,
                    rutEmpresa: this.formData.rutEmpresa,
                    telefono: this.formData.telefono,
                    usuarios: this.formData.usuarios
                }
            },
        })
            .then((result) => {
                this.mostrarNotificaciones(1, result.data.mensajeGeneral)
                this.mostrarRegistrar = false
                //this.$router.push({ name: 'Login' });
            })
            .catch((error) => {
                let msjError = "Ups, lo sentimos no hemos podido procesar el inicio de Sesión"
                    
                    if (error.response) {
                        // El servidor respondió con un estado diferente de 2xx
                        msjError = `${error.response.data.mensajeGeneral}`;
                    } else if (error.request) {
                        // La solicitud fue hecha pero no se recibió respuesta
                        msjError = 'Ups, no se recibe respuesta desde el servidor, si el problema persiste contactar a soporte@vapp.cl, gracias';
                    } else if (error.message === 'Network Error') {
                        // Error de red específico
                        msjError = 'Ups, lo sentimos, pero no tenemos acceso a la url del servidor, si el problema persiste contactar a soporte@vapp.cl, gracias'
                    } else {
                        // Algo pasó al configurar la solicitud que provocó un error
                        msjError = `${error.message}`;
                    }
                    this.mostrarNotificaciones(3, msjError)
            })
            .finally(() => {
              this.registrando = false
            });
        },
        formatearRutEmpresa: function() {
            this.formData.rutEmpresa = util.formatearRut(this.formData.rutEmpresa)
            this.formData.rutEmpresaValidado = util.validarRut(this.formData.rutEmpresa)
        },
        formatearRutUsuario: function(usuario) {
            usuario.rutUsuario = util.formatearRut(usuario.rutUsuario)
            usuario.rutUsuarioValidado = util.validarRut(usuario.rutUsuario)
        },
        validarCorreo: function(usuario) {
            if (usuario.correoUsuario == "" || usuario.correoUsuario == null){
                usuario.correoUsuarioValidado = false
            } else {
                usuario.correoUsuarioValidado = this.regMail.test(usuario.correoUsuario)
            }
        },
        /* validarTelefono: function() {
            console.log("Input detectado: ", this.formData.telefono);

            // Elimina los caracteres que no son números y también elimina ceros iniciales
            const numeroFormatear = this.formData.telefono.replace(/[^0-9]/g, ""); 
            
            // Actualiza el valor formateado en el input
            this.formData.telefono = numeroFormatear;

            // Si aún quedan caracteres que no son números, se limpia el campo
            const soloNumeros = /^[0-9]*$/;
            if (!soloNumeros.test(this.formData.telefono)) {
                this.formData.telefonoError = "Solo se permiten números.";
            } else {
                this.formData.telefonoError = "";
            }
        }*/
        formatearTelefono () {
            const { numAFormatear, error } = util.validarTelefono(this.formData.telefono);

            this.formData.telefono = numAFormatear;
            this.formData.telefonoError = error;
        }
  },
};  
</script>

<style>

.cardPrincipal{
    margin-top: 15px;
    border-radius: 25px;
}

.cardHeader{
    margin-top: 15px;
    padding: 0;
}
.cardHeader h2{
  color: #1b1b1bcc;
}

.cardUsuario{
    padding: 0;
    margin-top: 5px;
}

.titulos{
    font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
    font-size: 18px;
    color: #252525cc;
}   

.btnAgregarUsuario {
    font-size: 16px;
    color: white;
    background-color:#25939D;
    border-color:#25939D;
    margin-top: 0;
    width: auto;
}

.btnEliminarUsuario{
    font-size: 13px;
}

.formulario{
  width: 750px;
}

* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-family: 'Poppins', sans-serif;
}

img {
    max-width: 100%;
    height: auto;
}

/* Estilos de la estructura principal */
.principal {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 100vh;
    background-image: "/img/mix.png";
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    padding: 20px;
}

section {
    position: relative;
    max-width: 800px;
    width: 100%;
    background-color: rgba(255, 255, 255, 0.1);    
    border-radius: 20px;
    backdrop-filter: blur(55px);
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 2rem 3rem;
}

.sectionMovil section{
    border: none;
}
.sectionWeb section{
    border: 2px solid rgba(255, 255, 255, 0.5);
}

h1 {
    font-size: 2rem;
    color: #fff;
    text-align: center;
}

.inputbox {
    position: relative;
    margin: 20px 0;
    width: 100%;
    border-bottom: 2px solid #fff;
}

.inputbox label {
    position: absolute;
    top: 50%;
    left: 5px;
    transform: translateY(-50%);
    color: #fff;
    font-size: 0.8rem;
    pointer-events: none;
    transition: all 0.5s ease-in-out;
}

input:focus ~ label, 
input:valid ~ label {
    top: -5px;
}

.inputbox input {
    width: 100%;
    height: 30px;
    background: transparent;
    border: none;
    outline: none;
    font-size: 1rem;
    padding: 0 35px 0 5px;
    color: #fff;
}

.inputbox .c-icon, .inputbox ion-icon {
    position: absolute;
    right: 8px;
    color: #fff;
    font-size: 1.2rem;
    top: 20px;
}

.forget, .msjs {
    font-size: 0.75rem;
    color: #fff;
    display: flex;
    justify-content: space-between;
}

.forget label, .msjs label {
    display: flex;
    align-items: center;
}

.forget label input, .msjs label input {
    margin-right: 3px;
}

.forget a, .msjs a {
    color: #fff;
    text-decoration: none;
    font-weight: 600;
}

.forget a:hover, .msjs a:hover {
    text-decoration: underline;
}

button {
    width: 100%;
    height: 40px;
    border-radius: 40px;
    background-color: rgba(255, 255, 255, 1);
    border: none;
    outline: none;
    cursor: pointer;
    font-size: 1rem;
    font-weight: 600;
    transition: all 0.4s ease;
}

button:hover {
    background-color: rgba(255, 255, 255, 0.5);
}

.register {
    font-size: 0.9rem;
    color: #fff;
    text-align: center;
    margin: 25px 0 10px;
}

.register p a {
    text-decoration: none;
    color: #fff;
    font-weight: 600;
}

.register p a:hover {
    text-decoration: underline;
}

.version {
    font-size: 0.6rem;
    text-decoration: none;
    color: #fff;
    font-weight: 100;
}

.registrar{
    padding-bottom: 10px;
    color: white;
}

.link{
    color: #fff;
    text-decoration: underline;
}

.link:hover{
    color: #fff;
    filter: brightness(0.8);
}

/* Media Queries para pantallas más pequeñas */
@media (max-width: 768px) {
    section {
        padding: 1.5rem 2rem;
    }

    h1 {
        font-size: 1.8rem;
    }

    button {
        height: 35px;
    }
}

@media (max-width: 480px) {
    section {
        padding: 1rem 1.5rem;
    }

    h1 {
        font-size: 1.5rem;
    }

    button {
        height: 30px;
        font-size: 0.9rem;
    }
}

</style>